module.exports = __webpack_public_path__ + "img/parts_blue.497037b8.svg";